// ==============================
// src/services/documento.js
// Servicio de documentos (RAG) para botbase
// ==============================

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8003';

// ============================================================
// UTILIDADES
// ============================================================

function getToken() {
  return localStorage.getItem('auth_token');
}

function getAuthHeader() {
  const token = getToken();
  const headers = { 'ngrok-skip-browser-warning': 'true' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
}

// ============================================================
// SUBIR DOCUMENTO (POST /documento/)
// multipart/form-data: empresa_id, descripcion, archivo
// ============================================================

export async function subirDocumento(empresaId, archivo, descripcion = '') {
  const formData = new FormData();
  formData.append('empresa_id', empresaId);
  formData.append('descripcion', descripcion || '');
  formData.append('archivo', archivo);

  const response = await fetch(`${API_URL}/api/v1/documento/`, {
    method: 'POST',
    headers: getAuthHeader(), // NO poner Content-Type: el navegador lo pone con boundary
    body: formData,
  });

  if (!response.ok) {
    let errorMsg = 'Error al subir el documento';
    try {
      const error = await response.json();
      errorMsg = error.detail || errorMsg;
    } catch (_) {}
    throw new Error(errorMsg);
  }

  return response.json();
}

// ============================================================
// LISTAR DOCUMENTOS (GET /documento/?empresa_id=X)
// ============================================================

export async function listarDocumentos(empresaId, activosOnly = true) {
  const url = `${API_URL}/api/v1/documento/?empresa_id=${encodeURIComponent(empresaId)}&activos_only=${activosOnly}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      ...getAuthHeader(),
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    let errorMsg = 'Error al obtener los documentos';
    try {
      const error = await response.json();
      errorMsg = error.detail || errorMsg;
    } catch (_) {}
    throw new Error(errorMsg);
  }

  return response.json();
}

// ============================================================
// OBTENER UN DOCUMENTO POR ID (GET /documento/{id})
// ============================================================

export async function obtenerDocumento(documentoId) {
  const response = await fetch(`${API_URL}/api/v1/documento/${documentoId}`, {
    method: 'GET',
    headers: {
      ...getAuthHeader(),
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    let errorMsg = 'Error al obtener el documento';
    try {
      const error = await response.json();
      errorMsg = error.detail || errorMsg;
    } catch (_) {}
    throw new Error(errorMsg);
  }

  return response.json();
}

// ============================================================
// ELIMINAR DOCUMENTO (DELETE /documento/{id}) - soft delete
// ============================================================

export async function eliminarDocumento(documentoId) {
  const response = await fetch(`${API_URL}/api/v1/documento/${documentoId}`, {
    method: 'DELETE',
    headers: getAuthHeader(),
  });

  if (!response.ok) {
    let errorMsg = 'Error al eliminar el documento';
    try {
      const error = await response.json();
      errorMsg = error.detail || errorMsg;
    } catch (_) {}
    throw new Error(errorMsg);
  }

  return true;
}